import * as React from "react";
import { SvgIcon } from "@mui/material";

export function Iconify_tabler_DatabaseShare(props) {
    return (
        <SvgIcon {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                    <path d="M4 6c0 1.657 3.582 3 8 3s8-1.343 8-3s-3.582-3-8-3s-8 1.343-8 3" />
                    <path d="M4 6v6c0 1.657 3.582 3 8 3q.541 0 1.065-.026M20 13V6" />
                    <path d="M4 12v6c0 1.657 3.582 3 8 3m4 1l5-5m0 4.5V17h-4.5" />
                </g>
            </svg>
        </SvgIcon>
    );
}
